/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for RestaurationResource controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_FORMATIONAPI, CLIENT_CONTEXT_TOKEN_FORMATIONAPI } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions } from "../models";

@Injectable({ providedIn: "root" })
export class RestaurationResourceService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_FORMATIONAPI);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_FORMATIONAPI;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'formationApi');
    }

    restoreUtilisateur(idUtilisateur: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    restoreUtilisateur(idUtilisateur: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    restoreUtilisateur(idUtilisateur: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    restoreUtilisateur(idUtilisateur: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/restore-utilisateur`;

        let params = new HttpParams();
        if (idUtilisateur != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idUtilisateur, 'idUtilisateur');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    restoreUtilisateur1(idUtilisateur: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    restoreUtilisateur1(idUtilisateur: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    restoreUtilisateur1(idUtilisateur: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    restoreUtilisateur1(idUtilisateur: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/restore-utilisateur`;

        let params = new HttpParams();
        if (idUtilisateur != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idUtilisateur, 'idUtilisateur');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('post', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    restoreUtilisateur2(idUtilisateur: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    restoreUtilisateur2(idUtilisateur: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    restoreUtilisateur2(idUtilisateur: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    restoreUtilisateur2(idUtilisateur: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/restore-utilisateur`;

        let params = new HttpParams();
        if (idUtilisateur != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idUtilisateur, 'idUtilisateur');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('put', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    restoreUtilisateur4(idUtilisateur: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    restoreUtilisateur4(idUtilisateur: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    restoreUtilisateur4(idUtilisateur: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    restoreUtilisateur4(idUtilisateur: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/restore-utilisateur`;

        let params = new HttpParams();
        if (idUtilisateur != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idUtilisateur, 'idUtilisateur');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    restoreUtilisateur3(idUtilisateur: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    restoreUtilisateur3(idUtilisateur: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    restoreUtilisateur3(idUtilisateur: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    restoreUtilisateur3(idUtilisateur: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/restore-utilisateur`;

        let params = new HttpParams();
        if (idUtilisateur != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idUtilisateur, 'idUtilisateur');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('delete', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    restoreUtilisateur6(idUtilisateur: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    restoreUtilisateur6(idUtilisateur: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    restoreUtilisateur6(idUtilisateur: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    restoreUtilisateur6(idUtilisateur: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/restore-utilisateur`;

        let params = new HttpParams();
        if (idUtilisateur != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idUtilisateur, 'idUtilisateur');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('options', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    restoreUtilisateur5(idUtilisateur: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    restoreUtilisateur5(idUtilisateur: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    restoreUtilisateur5(idUtilisateur: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    restoreUtilisateur5(idUtilisateur: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/restore-utilisateur`;

        let params = new HttpParams();
        if (idUtilisateur != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idUtilisateur, 'idUtilisateur');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('head', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    restoreDiplome(idTypesDiplome: number, motifRestDiplome: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    restoreDiplome(idTypesDiplome: number, motifRestDiplome: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    restoreDiplome(idTypesDiplome: number, motifRestDiplome: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    restoreDiplome(idTypesDiplome: number, motifRestDiplome: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/restore-type-diplome`;

        let params = new HttpParams();
        if (idTypesDiplome != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idTypesDiplome, 'idTypesDiplome');
        }
        if (motifRestDiplome != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifRestDiplome, 'motifRestDiplome');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    restoreDiplome1(idTypesDiplome: number, motifRestDiplome: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    restoreDiplome1(idTypesDiplome: number, motifRestDiplome: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    restoreDiplome1(idTypesDiplome: number, motifRestDiplome: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    restoreDiplome1(idTypesDiplome: number, motifRestDiplome: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/restore-type-diplome`;

        let params = new HttpParams();
        if (idTypesDiplome != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idTypesDiplome, 'idTypesDiplome');
        }
        if (motifRestDiplome != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifRestDiplome, 'motifRestDiplome');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('post', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    restoreDiplome2(idTypesDiplome: number, motifRestDiplome: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    restoreDiplome2(idTypesDiplome: number, motifRestDiplome: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    restoreDiplome2(idTypesDiplome: number, motifRestDiplome: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    restoreDiplome2(idTypesDiplome: number, motifRestDiplome: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/restore-type-diplome`;

        let params = new HttpParams();
        if (idTypesDiplome != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idTypesDiplome, 'idTypesDiplome');
        }
        if (motifRestDiplome != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifRestDiplome, 'motifRestDiplome');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('put', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    restoreDiplome4(idTypesDiplome: number, motifRestDiplome: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    restoreDiplome4(idTypesDiplome: number, motifRestDiplome: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    restoreDiplome4(idTypesDiplome: number, motifRestDiplome: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    restoreDiplome4(idTypesDiplome: number, motifRestDiplome: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/restore-type-diplome`;

        let params = new HttpParams();
        if (idTypesDiplome != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idTypesDiplome, 'idTypesDiplome');
        }
        if (motifRestDiplome != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifRestDiplome, 'motifRestDiplome');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    restoreDiplome3(idTypesDiplome: number, motifRestDiplome: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    restoreDiplome3(idTypesDiplome: number, motifRestDiplome: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    restoreDiplome3(idTypesDiplome: number, motifRestDiplome: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    restoreDiplome3(idTypesDiplome: number, motifRestDiplome: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/restore-type-diplome`;

        let params = new HttpParams();
        if (idTypesDiplome != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idTypesDiplome, 'idTypesDiplome');
        }
        if (motifRestDiplome != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifRestDiplome, 'motifRestDiplome');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('delete', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    restoreDiplome6(idTypesDiplome: number, motifRestDiplome: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    restoreDiplome6(idTypesDiplome: number, motifRestDiplome: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    restoreDiplome6(idTypesDiplome: number, motifRestDiplome: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    restoreDiplome6(idTypesDiplome: number, motifRestDiplome: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/restore-type-diplome`;

        let params = new HttpParams();
        if (idTypesDiplome != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idTypesDiplome, 'idTypesDiplome');
        }
        if (motifRestDiplome != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifRestDiplome, 'motifRestDiplome');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('options', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    restoreDiplome5(idTypesDiplome: number, motifRestDiplome: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    restoreDiplome5(idTypesDiplome: number, motifRestDiplome: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    restoreDiplome5(idTypesDiplome: number, motifRestDiplome: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    restoreDiplome5(idTypesDiplome: number, motifRestDiplome: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/restore-type-diplome`;

        let params = new HttpParams();
        if (idTypesDiplome != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idTypesDiplome, 'idTypesDiplome');
        }
        if (motifRestDiplome != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifRestDiplome, 'motifRestDiplome');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('head', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    restoreIes(idIes: number, motifRestIes: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    restoreIes(idIes: number, motifRestIes: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    restoreIes(idIes: number, motifRestIes: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    restoreIes(idIes: number, motifRestIes: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/restore-ies`;

        let params = new HttpParams();
        if (idIes != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idIes, 'idIes');
        }
        if (motifRestIes != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifRestIes, 'motifRestIes');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    restoreIes1(idIes: number, motifRestIes: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    restoreIes1(idIes: number, motifRestIes: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    restoreIes1(idIes: number, motifRestIes: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    restoreIes1(idIes: number, motifRestIes: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/restore-ies`;

        let params = new HttpParams();
        if (idIes != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idIes, 'idIes');
        }
        if (motifRestIes != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifRestIes, 'motifRestIes');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('post', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    restoreIes2(idIes: number, motifRestIes: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    restoreIes2(idIes: number, motifRestIes: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    restoreIes2(idIes: number, motifRestIes: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    restoreIes2(idIes: number, motifRestIes: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/restore-ies`;

        let params = new HttpParams();
        if (idIes != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idIes, 'idIes');
        }
        if (motifRestIes != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifRestIes, 'motifRestIes');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('put', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    restoreIes4(idIes: number, motifRestIes: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    restoreIes4(idIes: number, motifRestIes: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    restoreIes4(idIes: number, motifRestIes: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    restoreIes4(idIes: number, motifRestIes: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/restore-ies`;

        let params = new HttpParams();
        if (idIes != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idIes, 'idIes');
        }
        if (motifRestIes != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifRestIes, 'motifRestIes');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    restoreIes3(idIes: number, motifRestIes: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    restoreIes3(idIes: number, motifRestIes: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    restoreIes3(idIes: number, motifRestIes: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    restoreIes3(idIes: number, motifRestIes: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/restore-ies`;

        let params = new HttpParams();
        if (idIes != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idIes, 'idIes');
        }
        if (motifRestIes != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifRestIes, 'motifRestIes');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('delete', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    restoreIes6(idIes: number, motifRestIes: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    restoreIes6(idIes: number, motifRestIes: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    restoreIes6(idIes: number, motifRestIes: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    restoreIes6(idIes: number, motifRestIes: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/restore-ies`;

        let params = new HttpParams();
        if (idIes != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idIes, 'idIes');
        }
        if (motifRestIes != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifRestIes, 'motifRestIes');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('options', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    restoreIes5(idIes: number, motifRestIes: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    restoreIes5(idIes: number, motifRestIes: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    restoreIes5(idIes: number, motifRestIes: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    restoreIes5(idIes: number, motifRestIes: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/restore-ies`;

        let params = new HttpParams();
        if (idIes != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idIes, 'idIes');
        }
        if (motifRestIes != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifRestIes, 'motifRestIes');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('head', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    restoreFormation(idFormation: number, motifRestFormation: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    restoreFormation(idFormation: number, motifRestFormation: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    restoreFormation(idFormation: number, motifRestFormation: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    restoreFormation(idFormation: number, motifRestFormation: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/restore-formation`;

        let params = new HttpParams();
        if (idFormation != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idFormation, 'idFormation');
        }
        if (motifRestFormation != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifRestFormation, 'motifRestFormation');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    restoreFormation1(idFormation: number, motifRestFormation: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    restoreFormation1(idFormation: number, motifRestFormation: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    restoreFormation1(idFormation: number, motifRestFormation: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    restoreFormation1(idFormation: number, motifRestFormation: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/restore-formation`;

        let params = new HttpParams();
        if (idFormation != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idFormation, 'idFormation');
        }
        if (motifRestFormation != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifRestFormation, 'motifRestFormation');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('post', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    restoreFormation2(idFormation: number, motifRestFormation: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    restoreFormation2(idFormation: number, motifRestFormation: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    restoreFormation2(idFormation: number, motifRestFormation: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    restoreFormation2(idFormation: number, motifRestFormation: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/restore-formation`;

        let params = new HttpParams();
        if (idFormation != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idFormation, 'idFormation');
        }
        if (motifRestFormation != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifRestFormation, 'motifRestFormation');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('put', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    restoreFormation4(idFormation: number, motifRestFormation: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    restoreFormation4(idFormation: number, motifRestFormation: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    restoreFormation4(idFormation: number, motifRestFormation: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    restoreFormation4(idFormation: number, motifRestFormation: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/restore-formation`;

        let params = new HttpParams();
        if (idFormation != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idFormation, 'idFormation');
        }
        if (motifRestFormation != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifRestFormation, 'motifRestFormation');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    restoreFormation3(idFormation: number, motifRestFormation: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    restoreFormation3(idFormation: number, motifRestFormation: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    restoreFormation3(idFormation: number, motifRestFormation: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    restoreFormation3(idFormation: number, motifRestFormation: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/restore-formation`;

        let params = new HttpParams();
        if (idFormation != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idFormation, 'idFormation');
        }
        if (motifRestFormation != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifRestFormation, 'motifRestFormation');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('delete', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    restoreFormation6(idFormation: number, motifRestFormation: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    restoreFormation6(idFormation: number, motifRestFormation: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    restoreFormation6(idFormation: number, motifRestFormation: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    restoreFormation6(idFormation: number, motifRestFormation: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/restore-formation`;

        let params = new HttpParams();
        if (idFormation != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idFormation, 'idFormation');
        }
        if (motifRestFormation != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifRestFormation, 'motifRestFormation');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('options', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    restoreFormation5(idFormation: number, motifRestFormation: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    restoreFormation5(idFormation: number, motifRestFormation: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    restoreFormation5(idFormation: number, motifRestFormation: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    restoreFormation5(idFormation: number, motifRestFormation: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/restore-formation`;

        let params = new HttpParams();
        if (idFormation != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idFormation, 'idFormation');
        }
        if (motifRestFormation != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifRestFormation, 'motifRestFormation');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('head', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    restoreEtablissement(idEtablissement: number, motifRestEtablissement: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    restoreEtablissement(idEtablissement: number, motifRestEtablissement: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    restoreEtablissement(idEtablissement: number, motifRestEtablissement: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    restoreEtablissement(idEtablissement: number, motifRestEtablissement: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/restore-etablissement`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }
        if (motifRestEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifRestEtablissement, 'motifRestEtablissement');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    restoreEtablissement1(idEtablissement: number, motifRestEtablissement: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    restoreEtablissement1(idEtablissement: number, motifRestEtablissement: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    restoreEtablissement1(idEtablissement: number, motifRestEtablissement: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    restoreEtablissement1(idEtablissement: number, motifRestEtablissement: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/restore-etablissement`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }
        if (motifRestEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifRestEtablissement, 'motifRestEtablissement');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('post', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    restoreEtablissement2(idEtablissement: number, motifRestEtablissement: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    restoreEtablissement2(idEtablissement: number, motifRestEtablissement: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    restoreEtablissement2(idEtablissement: number, motifRestEtablissement: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    restoreEtablissement2(idEtablissement: number, motifRestEtablissement: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/restore-etablissement`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }
        if (motifRestEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifRestEtablissement, 'motifRestEtablissement');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('put', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    restoreEtablissement4(idEtablissement: number, motifRestEtablissement: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    restoreEtablissement4(idEtablissement: number, motifRestEtablissement: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    restoreEtablissement4(idEtablissement: number, motifRestEtablissement: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    restoreEtablissement4(idEtablissement: number, motifRestEtablissement: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/restore-etablissement`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }
        if (motifRestEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifRestEtablissement, 'motifRestEtablissement');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    restoreEtablissement3(idEtablissement: number, motifRestEtablissement: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    restoreEtablissement3(idEtablissement: number, motifRestEtablissement: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    restoreEtablissement3(idEtablissement: number, motifRestEtablissement: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    restoreEtablissement3(idEtablissement: number, motifRestEtablissement: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/restore-etablissement`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }
        if (motifRestEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifRestEtablissement, 'motifRestEtablissement');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('delete', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    restoreEtablissement6(idEtablissement: number, motifRestEtablissement: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    restoreEtablissement6(idEtablissement: number, motifRestEtablissement: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    restoreEtablissement6(idEtablissement: number, motifRestEtablissement: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    restoreEtablissement6(idEtablissement: number, motifRestEtablissement: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/restore-etablissement`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }
        if (motifRestEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifRestEtablissement, 'motifRestEtablissement');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('options', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    restoreEtablissement5(idEtablissement: number, motifRestEtablissement: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    restoreEtablissement5(idEtablissement: number, motifRestEtablissement: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    restoreEtablissement5(idEtablissement: number, motifRestEtablissement: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    restoreEtablissement5(idEtablissement: number, motifRestEtablissement: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/restore-etablissement`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }
        if (motifRestEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifRestEtablissement, 'motifRestEtablissement');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('head', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    restoreDomaine(idDomaine: number, motifRestDomaine: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    restoreDomaine(idDomaine: number, motifRestDomaine: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    restoreDomaine(idDomaine: number, motifRestDomaine: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    restoreDomaine(idDomaine: number, motifRestDomaine: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/restore-domaine`;

        let params = new HttpParams();
        if (idDomaine != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idDomaine, 'idDomaine');
        }
        if (motifRestDomaine != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifRestDomaine, 'motifRestDomaine');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    restoreDomaine1(idDomaine: number, motifRestDomaine: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    restoreDomaine1(idDomaine: number, motifRestDomaine: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    restoreDomaine1(idDomaine: number, motifRestDomaine: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    restoreDomaine1(idDomaine: number, motifRestDomaine: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/restore-domaine`;

        let params = new HttpParams();
        if (idDomaine != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idDomaine, 'idDomaine');
        }
        if (motifRestDomaine != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifRestDomaine, 'motifRestDomaine');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('post', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    restoreDomaine2(idDomaine: number, motifRestDomaine: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    restoreDomaine2(idDomaine: number, motifRestDomaine: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    restoreDomaine2(idDomaine: number, motifRestDomaine: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    restoreDomaine2(idDomaine: number, motifRestDomaine: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/restore-domaine`;

        let params = new HttpParams();
        if (idDomaine != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idDomaine, 'idDomaine');
        }
        if (motifRestDomaine != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifRestDomaine, 'motifRestDomaine');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('put', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    restoreDomaine4(idDomaine: number, motifRestDomaine: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    restoreDomaine4(idDomaine: number, motifRestDomaine: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    restoreDomaine4(idDomaine: number, motifRestDomaine: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    restoreDomaine4(idDomaine: number, motifRestDomaine: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/restore-domaine`;

        let params = new HttpParams();
        if (idDomaine != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idDomaine, 'idDomaine');
        }
        if (motifRestDomaine != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifRestDomaine, 'motifRestDomaine');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    restoreDomaine3(idDomaine: number, motifRestDomaine: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    restoreDomaine3(idDomaine: number, motifRestDomaine: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    restoreDomaine3(idDomaine: number, motifRestDomaine: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    restoreDomaine3(idDomaine: number, motifRestDomaine: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/restore-domaine`;

        let params = new HttpParams();
        if (idDomaine != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idDomaine, 'idDomaine');
        }
        if (motifRestDomaine != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifRestDomaine, 'motifRestDomaine');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('delete', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    restoreDomaine6(idDomaine: number, motifRestDomaine: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    restoreDomaine6(idDomaine: number, motifRestDomaine: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    restoreDomaine6(idDomaine: number, motifRestDomaine: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    restoreDomaine6(idDomaine: number, motifRestDomaine: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/restore-domaine`;

        let params = new HttpParams();
        if (idDomaine != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idDomaine, 'idDomaine');
        }
        if (motifRestDomaine != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifRestDomaine, 'motifRestDomaine');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('options', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    restoreDomaine5(idDomaine: number, motifRestDomaine: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    restoreDomaine5(idDomaine: number, motifRestDomaine: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    restoreDomaine5(idDomaine: number, motifRestDomaine: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    restoreDomaine5(idDomaine: number, motifRestDomaine: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/restore-domaine`;

        let params = new HttpParams();
        if (idDomaine != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idDomaine, 'idDomaine');
        }
        if (motifRestDomaine != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifRestDomaine, 'motifRestDomaine');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('head', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
